import React from 'react';
import Router from 'next/router';
import AccessDeniedIcon from '../../../public/static/images/new_ad/icons/icon-access-denied.svg';
import Icon from '../../Icon';
import {
  ErrorContainer,
  Title,
  Message,
  MessageContainer,
  ButtonContainer
} from './styled';
import { Button } from '../Button';

interface ErrorPageProps {
  title: string;
  message: string;
  buttonName?: string;
  onClick?: () => void;
}

export const ErrorPage: React.FC<ErrorPageProps> = ({
  title,
  buttonName,
  message,
  onClick = () => Router.reload()
}) => (
  <ErrorContainer>
    <Icon
      width={250}
      height={250}
      indent={false}
      IconComponent={AccessDeniedIcon}
      dataCypress="error-icon"
    />
    <MessageContainer>
      <Title tag="h4_new" data-cy="error-page__title">
        {title}
      </Title>
      <Message data-cy="error-page__message">{message}</Message>
      {buttonName && (
        <ButtonContainer>
          <Button
            type="submit"
            text={buttonName}
            onClick={onClick}
            cypress="error-page__btn"
          />
        </ButtonContainer>
      )}
    </MessageContainer>
  </ErrorContainer>
);
